export class IBCFieldNames {
    static ID = "id";
    static SERVICE_ID = "serviceId";
    static STALLION_ID = "stallionId";
    static SEMEN_COLLECTION_CERTIFICATE_ID = "semenCollectionCertificateId";
    static TRANSPORTED_STORED_SEMEN_CERT_SERIAL_NO = "transportedStoredSemenCertificateSerialNumber";

    // Stallion display fields (read-only)
    static STALLION_NAME = "stallionName";
    static STALLION_REG_NO = "stallionRegNo";
    static STALLION_UELN = "stallionUELN";
    static STALLION_BIRTH_DATE = "stallionBirthDate";
    static STALLION_BIRTH_DATE_RAW = "stallionBirthDateRaw";
    static STALLION_COLOR = "stallionColor";
    static STALLION_ORIGIN = "stallionOrigin";
    static STALLION_BREEDER = "stallionBreeder";
    static STALLION_OWNER = "stallionOwner";

    // Mare fields
    static UNREGISTERED_MARE_ID = "unRegisteredMareId";
    static MARE_NAME_EN = "mareNameEn";
    static MARE_NAME_AR = "mareNameAr";
    static MARE_SIRE_NAME_EN = "mareSireNameEn";
    static MARE_SIRE_NAME_AR = "mareSireNameAr";
    static MARE_DAM_NAME_EN = "mareDamNameEn";
    static MARE_DAM_NAME_AR = "mareDamNameAr";
    static RECORDED_MARE_OWNER_NAME_EN = "recordedMareOwnerNameEn";
    static RECORDED_MARE_OWNER_NAME_AR = "recordedMareOwnerNameAr";
    static RECORDED_MARE_OWNER_PHONE = "recordedMareOwnerPhone";
    static MARE_BREEDER_NAME_EN = "mareBreederNameEn";
    static MARE_BREEDER_NAME_AR = "mareBreederNameAr";
    static MARE_HORSE_ADDRESS = "mareHorseAddress";
    static MARE_REGISTRATION_NUMBER = "mareRegistrationNumber";
    static MARE_UELN = "mareUeln";
    static COLOR_ID = "colorId";
    static MARE_ORIGIN_COUNTRY_ID = "mareOriginCountryId";
    static MARE_STUDBOOK_COUNTRY_ID = "mareStudbookCountryId";
    static MARE_BIRTH_DATE = "mareBirthDate";

    // Covering details
    static LAST_COVERING_DATE = "lastCoveringDate";

    // Comments & Workflow
    static COMMENT = "comment";
    static OWNER_COMMENT = "ownerComment";
    static STATUS = "status";
    static BUTTON_ACTION = "buttonAction";
    static REPORT_URL = "reportUrl";
}

export const IBC_SERVICE_DEFINITION_ID = "A12B88F7-F2D4-46DA-81DB-7299837D8A4E";
export const EMPTY_GUID = "00000000-0000-0000-0000-000000000000";

export const cleanGuid = (val) => {
    if (!val) return null;
    if (typeof val === 'string') {
        const trimmed = val.trim();
        if (
            trimmed === '' ||
            trimmed === EMPTY_GUID ||
            trimmed.toLowerCase() === 'null' ||
            trimmed.toLowerCase() === 'undefined'
        ) {
            return null;
        }
        return trimmed;
    }
    return val;
};

export const isValidGuid = (val) => {
    const cleaned = cleanGuid(val);
    if (!cleaned) return false;
    return /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(cleaned);
};

export const formatToIsoDateTime = (d) => {
    if (!d) return '';
    if (typeof d === 'string') {
        const clean = d.trim();
        const dmyMatch = clean.match(/^(\d{1,2})[/-](\d{1,2})[/-](\d{4})(?:T(.*))?$/);
        if (dmyMatch) {
            const day = dmyMatch[1].padStart(2, '0');
            const month = dmyMatch[2].padStart(2, '0');
            const year = dmyMatch[3];
            const time = dmyMatch[4] || '00:00:00';
            return `${year}-${month}-${day}T${time}`;
        }
        const ymdMatch = clean.match(/^(\d{4})-(\d{2})-(\d{2})$/);
        if (ymdMatch) {
            return `${clean}T00:00:00`;
        }
        if (clean.includes('T') && /^\d{4}-\d{2}-\d{2}T/.test(clean)) {
            return clean.split('.')[0];
        }
    }
    try {
        const dateObj = new Date(d);
        return !isNaN(dateObj) ? dateObj.toISOString().split('.')[0] : d;
    } catch {
        return d;
    }
};
